import { configureStore } from '@reduxjs/toolkit';
import apiInfoReducer from '../features/api-info/api-infoSlice';
import eventsReducer from '../features/events/eventSlice'
import userReducer from '../features/user/user-slice'
import notificationReducer from '../features/notifications/notifcationSlice';
import studyNotesReducer from '../features/study-note/studyNoteSlice';
import statisticsReducer from '../features/statistics/statisticsSlice';
import iamReducer from '../features/user-management/iamSlice';

export const store = configureStore({
  reducer: {
    events: eventsReducer,
    apiInfo: apiInfoReducer,
    user: userReducer,
    notification: notificationReducer,
    studyNotes: studyNotesReducer,
    statistics: statisticsReducer,
    iam: iamReducer
  },
});
